// extracted by mini-css-extract-plugin
export default {"container":"component_container__wthvn","title1":"component_title1__Wxa08","list":"component_list__n4lnM","listItem":"component_listItem__1K99O"};